import { useSettings } from "@/hooks/useSettings";

const META = {
  mentions: { title: "Mentions légales", field: "mentions_legales" },
  cgv: { title: "Conditions Générales de Vente", field: "cgv" },
  privacy: { title: "Politique de confidentialité", field: "privacy" },
  cookies: { title: "Politique de cookies", field: "cookies" },
  refund: { title: "Politique de remboursement", field: null },
};

export default function LegalPage({ kind }) {
  const { data: s } = useSettings();
  const meta = META[kind];
  const legal = s?.legal || {};
  const refund = s?.refund_policy || {};

  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
      <h1 className="font-heading text-4xl text-ink tracking-tight mb-8">{meta.title}</h1>
      <div className="bg-cream border border-line rounded-lg p-8 text-ink-muted leading-relaxed space-y-4 text-sm">
        {kind === "mentions" && (
          <>
            <Row label="Nom commercial" value={legal.company_name} />
            <Row label="Éditeur / Responsable" value={legal.editor} />
            <Row label="Immatriculation (RCS)" value={legal.rcs} />
            {legal.siret ? <Row label="SIRET" value={legal.siret} /> : null}
            {legal.kbis ? <Row label="Kbis" value={legal.kbis} /> : null}
            <Row label="Adresse" value={legal.address} />
            <Row label="Site web" value={legal.domain} />
            <Row label="E-mail de contact" value={legal.email} />
            <Row label="E-mail support" value={s?.support_email} />
            <Row label="TVA" value={legal.vat} />
            {legal.phone ? <Row label="Téléphone" value={legal.phone} /> : null}
            <p className="pt-4 whitespace-pre-line">{legal.mentions_legales}</p>
          </>
        )}
        {kind === "refund" && (
          <>
            <Row label="Durée" value={refund.duration_days ? `${refund.duration_days} jours` : null} />
            <Row label="E-mail de contact" value={refund.email} />
            <p className="pt-2 whitespace-pre-line">{refund.text}</p>
            <p className="whitespace-pre-line"><strong className="text-ink">Conditions :</strong> {refund.conditions}</p>
            <p className="whitespace-pre-line"><strong className="text-ink">Procédure :</strong> {refund.procedure}</p>
          </>
        )}
        {["cgv", "privacy", "cookies"].includes(kind) && (
          <p className="whitespace-pre-line">{legal[meta.field] || "À COMPLÉTER"}</p>
        )}
        <p className="pt-6 text-xs text-ink-muted border-t border-line mt-6">Ce contenu doit être complété et validé avant la mise en production. Les champs marqués « À COMPLÉTER » sont configurables depuis l'espace d'administration.</p>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return <p><strong className="text-ink">{label} :</strong> {value || <span className="italic text-terracotta">À COMPLÉTER</span>}</p>;
}
